<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          v-if="permission.examineplan_add"
          @click="openExaminePlanAddDialog"
          >新 增
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button
          type="text"
          size="small"
          icon="el-icon-view"
          v-if="permission.examineplan_view"
          @click="openExaminePlanViewDialog(scope.row)"
          >查看
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit"
          v-if="permission.examineplan_edit"
          @click="openExaminePlanEditDialog(scope.row)"
          :hidden="hideEditBtn(scope.row)"
          >修改
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-delete"
          v-if="permission.examineplan_delete"
          @click="rowDel(scope.row)"
          :hidden="hideDelBtn(scope.row)"
          >删除
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-thumb"
          v-if="permission.examineplan_delete"
          @click="publish(scope.row)"
          :hidden="hidePublishBtn(scope.row)"
          >发布
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-thumb"
          v-if="permission.examineplan_delete"
          @click="createReport(scope.row)"
          :hidden="hideCreateReportBtn(scope.row)"
          >生成报告
        </el-button>
      </template>
    </avue-crud>
    <el-dialog
      width="60%"
      title="新增"
      :visible.sync="openExaminePlanAddDialogFlag"
      v-if="openExaminePlanAddDialogFlag"
      :modal-append-to-body="false"
      append-to-body
      @close="quitExaminePlanAddDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="examinePlanAddFormRef"
          v-model="examinePlanAddForm"
          :option="examinePlanAddOption"
          @submit="examinePlanAddSubmit"
        >
          <template slot="test" slot-scope="">
            <el-transfer
              filterable
              filter-placeholder="请输入内容名称"
              :titles="['未选内容', '目标内容']"
              :props="{
                key: 'id',
                label: 'name',
              }"
              v-model="addValue"
              :data="examineRepositoryList"
            >
            </el-transfer>
          </template>
          <!-- 人员选择 -->
          <template slot="userIds" slot-scope="">
            <UserEditBox2
              v-model="examinePlanAddForm.userIds"
              :remainUserListInside.sync="remainUserList"
              :projectId="userEditBoxProjectId"
            />
          </template>
          <!--  -->
          <template slot="systemNotifyWays">
            <el-select
              v-model="examinePlanAddForm.systemNotifyWays"
              ref="systemNotifyWays"
              multiple
            >
              <el-option
                v-for="(item, index) in systemNotifyWaysList"
                :key="index"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
          </template>

          <template slot="testLabel" slot-scope="">
            <span
              ><span style="color: red">*&nbsp;</span
              >考核内容:&nbsp;&nbsp;</span
            >
          </template>
          <template slot-scope="" slot="menuForm">
            <el-button @click="quitExaminePlanAddDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      width="60%"
      title="修改"
      :visible.sync="openExaminePlanEditDialogFlag"
      v-if="openExaminePlanEditDialogFlag"
      :modal-append-to-body="false"
      append-to-body
      @close="quitExaminePlanEditDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="examinePlanEditFormRef"
          v-model="examinePlanEditForm"
          :option="examinePlanEditOption"
          @submit="examinePlanEditSubmit"
        >
          <template slot="test" slot-scope="">
            <el-transfer
              filterable
              filter-placeholder="请输入内容名称"
              :titles="['未选内容', '目标内容']"
              :props="{
                key: 'id',
                label: 'name',
              }"
              v-model="editValue"
              :data="examineRepositoryList"
            >
            </el-transfer>
          </template>
          <!-- 人员选择 -->
          <template slot="userIds" slot-scope="">
            <UserEditBox2
              v-model="examinePlanEditForm.userIds"
              :remainUserListInside.sync="remainUserList"
              :projectId="userEditBoxProjectId"
            />
          </template>
          <!--  -->
          <template slot="systemNotifyWays">
            <el-select
              v-model="examinePlanEditForm.systemNotifyWays"
              ref="systemNotifyWays"
              multiple
            >
              <el-option
                v-for="(item, index) in systemNotifyWaysList"
                :key="index"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
          </template>
          <template slot="testLabel" slot-scope="">
            <span
              ><span style="color: red">*&nbsp;</span
              >考核题目:&nbsp;&nbsp;</span
            >
          </template>
          <template slot-scope="" slot="menuForm">
            <el-button @click="quitExaminePlanEditDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      width="60%"
      title="查看"
      :visible.sync="openExaminePlanViewDialogFlag"
      :modal-append-to-body="false"
      @close="quitExaminePlanViewDialog"
    >
      <div v-if="openExaminePlanViewDialogFlag" class="el-property-dialog-div">
        <avue-form
          ref="examinePlanViewFormRef"
          v-model="examinePlanViewForm"
          :option="examinePlanViewOption"
        >
          <template slot="test" slot-scope="">
            <avue-crud :data="viewTopicData" :option="topicOption"></avue-crud>
          </template>

          <template slot="systemNotifyWays">
            <el-select
              v-model="examinePlanViewForm.systemNotifyWays"
              ref="systemNotifyWays"
              multiple
              disabled
              placeholder=""
            >
              <el-option
                v-for="(item, index) in systemNotifyWaysList"
                :key="index"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
          </template>

          <template slot="testLabel" slot-scope="">
            <span>考核题目:&nbsp;&nbsp;</span>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      title="发布任务"
      append-to-body
      :visible.sync="openPublishFlag"
      @close="closePublishDialog"
    >
      <avue-form
        v-model="openPublishForm"
        ref="openPublishFormRef"
        :option="openPublishOption"
        @submit="openPublishSubmit"
      >
      </avue-form>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getExamineTopicList,
  generate,
  getPlanTopicIdListByPlanId,
  getPlanTopicListByPlanId,
  getTaskReport,
  getDictionary,
  getProjectUserList,
} from "@/api/crmedical/examine/plan/examineplan";
import { mapGetters } from "vuex";
import examinePlanAddOption from "./examineplan-add-option";
import examinePlanEditOption from "./examineplan-edit-option";
import examinePlanViewOption from "./examineplan-view-option";
import { getProjectList } from "@/api/crmedical/project/project";
import { getProjectDict } from "@/api/crmedical/project-dictionary/project-dictionary";
import { createTaskByPlanId } from "@/api/crmedical/examine/task/examinetask";
import { getContractList } from "@/api/crmedical/contract/contract/contract";
import UserEditBox2 from "@/views/components/user-edit-box2";

export default {
  components: {
    UserEditBox2,
  },
  data: function () {
    return {
      //人员选择
      dialogUserEditBoxVisible: false, //显隐
      userEditBoxProjectId: "", //项目id
      selectUserType: "",
      remainUserList: [],
      handleAction: "",
      //人员选择end
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      firstDisplayFlag: false,
      reWrite: false,
      tempProjectId: "",
      projectList: [],
      examineRepositoryList: [],
      addValue: [],
      editValue: [],
      viewTopicData: [],
      examinePlanAddForm: {},
      examinePlanEditForm: {},
      examinePlanViewForm: {},
      examinePlanAddOption: examinePlanAddOption,
      examinePlanEditOption: examinePlanEditOption,
      examinePlanViewOption: examinePlanViewOption,
      openExaminePlanAddDialogFlag: false,
      openExaminePlanEditDialogFlag: false,
      openExaminePlanViewDialogFlag: false,
      option: {
        height: "auto",
        calcHeight: 50,
        tip: false,
        border: true,
        indexLabel: "序号",
        index: true,
        selection: true,
        columnBtn: false,
        refreshBtn: false,
        addBtn: false,
        editBtn: false,
        viewBtn: false,
        delBtn: false,
        searchMenuSpan: 6,
        column: [
          {
            label: "主键",
            prop: "id",
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
          },
          {
            label: "项目名称",
            prop: "projectId",
            type: "tree",
            cascaderItem: ["serviceType"],
            searchClearable: false,
            search: true,
            dicUrl: "/api/v4ward/project/getProjectList",
            props: { label: "name", value: "id" },
          },
          {
            label: "计划名称",
            prop: "name",
            search: true,
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
          },
          {
            label: "考核班组",
            prop: "groupName",
            search: true,
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
          },
          {
            label: "考核对象",
            prop: "serviceType",
            type: "select",
            search: true,
            dataType: "string",
            dicUrl:
              "api/v4ward/projectDict/dictionary?code=project_examine_service_type&projectId={{key}}",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
          },
          {
            label: "考核人员",
            prop: "userNames",
            overHidden: true,
          },
          {
            label: "合格比例（%）",
            prop: "criterionScore",
            maxlength: 6,
            showWordLimit: true,
          },
          {
            label: "计算类型",
            prop: "calculateType",
            type: "select",
            dataType: "number",
            dicUrl: "api/blade-system/dict/dictionary?code=calculate_type",
            props: { label: "dictValue", value: "dictKey" },
          },
        ],
      },
      topicOption: {
        calcHeight: 50,
        height: "400",
        indexLabel: "序号",
        page: false,
        border: true,
        addBtn: false,
        selection: false,
        tip: false,
        columnBtn: false,
        refreshBtn: false,
        menuAlign: "center",
        menu: false,
        column: [
          {
            label: "标准内容",
            prop: "content",
            span: 24,
            row: 4,
            maxlength: 200,
            showWordLimit: true,
            overHidden: true,
          },
          {
            label: "考核要求",
            prop: "demand",
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
          },
          {
            label: "分值",
            prop: "score",
            maxlength: 6,
            showWordLimit: true,
          },
          {
            label: "排序",
            prop: "sort",
            maxlength: 6,
            showWordLimit: true,
          },
        ],
      },
      //发布任务页面option
      openPublishFlag: false,
      openPublishForm: {},
      planId: "",
      openPublishOption: {
        align: "center",
        addBtn: false,
        emptyBtn: false,
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: "发布日期",
            prop: "planTimeRange",
            searchRange: true,
            type: "datetimerange",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            span: 24,
            row: true,
            pickerOptions: {
              disabledDate(time) {
                let dateTime = new Date();
                dateTime = dateTime.setDate(dateTime.getDate() - 1);
                dateTime = new Date(dateTime);
                return time.getTime() < dateTime;
              },
            },
            rules: [
              {
                required: true,
                message: "请选择发布日期",
                trigger: "blur",
              },
            ],
          },
        ],
      },
      data: [],
      systemNotifyWaysList: [], //通知方式列表
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.examineplan_add, false),
        viewBtn: this.vaildData(this.permission.examineplan_view, false),
        delBtn: this.vaildData(this.permission.examineplan_delete, false),
        editBtn: this.vaildData(this.permission.examineplan_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  created() {
    //加载列表
    getProjectList({}).then((res) => {
      this.projectList = res.data;
      if (this.projectList.length > 0) {
        this.query.projectId = this.projectList[0].id;
        this.tempProjectId = this.projectList[0].id;
        getProjectDict({
          projectId: this.query.projectId,
          code: "project_examine_service_type",
        }).then(({ data }) => {
          this.findObject(this.option.column, "serviceType").dicData = data;
        });
      }
      this.$nextTick(() => {
        this.reWrite = true;
      });
      //每次刷新页面时，开启房产搜索框默认显示第一个节点的名称
      this.firstDisplayFlag = true;
    });
    //获取通知方式列表
    getDictionary({ code: "system_notify_way" }).then((res) => {
      console.log("res systemNotifyWaysList==>", res);
      this.systemNotifyWaysList = res.data;
    });
  },
  watch: {
    "form.projectId"() {
      this.query.serviceType = "";
    },
    "examinePlanAddForm.projectId"(val) {
      // 人员选择器
      this.userEditBoxProjectId = val;
      // 人员选择器end
      if (
        this.examinePlanAddForm.serviceType &&
        this.examinePlanAddForm.projectId
      ) {
        this.addValue = [];
        //根据项目id获取题库
        getExamineTopicList({
          projectId: this.examinePlanAddForm.projectId,
          serviceType: this.examinePlanAddForm.serviceType,
        }).then((res) => {
          this.examineRepositoryList = res.data;
        });
      }
      if (this.examinePlanAddForm.projectId) {
        this.examinePlanAddForm.serviceType = "";
        this.examinePlanAddForm.contractId = "";
        this.findObject(
          this.examinePlanAddOption.group[0].column,
          "serviceType"
        ).dicData = [
          {
            label: "",
            value: "",
          },
        ];

        this.findObject(
          this.examinePlanAddOption.group[0].column,
          "contractId"
        ).dicData = [
          {
            label: "",
            value: "",
          },
        ];
        getProjectDict({
          projectId: this.examinePlanAddForm.projectId,
          code: "project_examine_service_type",
        }).then(({ data }) => {
          this.findObject(
            this.examinePlanAddOption.group[0].column,
            "serviceType"
          ).dicData = data;
        });

        getContractList({
          projectId: this.examinePlanAddForm.projectId,
        }).then(({ data }) => {
          this.findObject(
            this.examinePlanAddOption.group[0].column,
            "contractId"
          ).dicData = data;
        });
      }
    },
    "examinePlanAddForm.serviceType"() {
      if (
        this.examinePlanAddForm.serviceType &&
        this.examinePlanAddForm.projectId
      ) {
        this.addValue = [];
        //根据项目id获取题库
        getExamineTopicList({
          projectId: this.examinePlanAddForm.projectId,
          serviceType: this.examinePlanAddForm.serviceType,
        }).then((res) => {
          this.examineRepositoryList = res.data;
        });
      }
    },
    "examinePlanEditForm.serviceType"() {
      if (
        this.examinePlanEditForm.serviceType &&
        this.examinePlanEditForm.projectId
      ) {
        this.editValue = [];
        //根据项目id获取题库
        getExamineTopicList({
          projectId: this.query.projectId,
          serviceType: this.examinePlanEditForm.serviceType,
        }).then((res) => {
          this.examineRepositoryList = res.data;
        });
      }
    },
    "examinePlanEditForm.projectId"() {
      if (this.examinePlanEditForm.projectId) {
        getProjectDict({
          projectId: this.examinePlanEditForm.projectId,
          code: "project_examine_service_type",
        }).then(({ data }) => {
          this.findObject(
            this.examinePlanEditOption.group[0].column,
            "serviceType"
          ).dicData = data;
        });

        getContractList({
          projectId: this.examinePlanEditForm.projectId,
        }).then(({ data }) => {
          this.findObject(
            this.examinePlanEditOption.group[0].column,
            "contractId"
          ).dicData = data;
        });
      }
    },
    "examinePlanViewForm.projectId"() {
      if (this.examinePlanViewForm.projectId) {
        getProjectDict({
          projectId: this.examinePlanViewForm.projectId,
          code: "project_examine_service_type",
        }).then(({ data }) => {
          this.findObject(
            this.examinePlanViewOption.group[0].column,
            "serviceType"
          ).dicData = data;
        });
        getContractList({
          projectId: this.examinePlanViewForm.projectId,
        }).then(({ data }) => {
          this.findObject(
            this.examinePlanViewOption.group[0].column,
            "contractId"
          ).dicData = data;
        });
      }
    },
  },
  methods: {
    //人员选择器
    // handleCloseAction(val) {
    //   this.dialogUserEditBoxVisible = false;
    // },
    // handleSubmitAction(val) {
    //   console.log(val);
    //   this.formUserNames = val.nameListString;
    //   this.remainUserList = val.dataSelectedUsers;

    //   this.examinePlanAddForm.userIds = val.idListString;
    //   this.dialogUserEditBoxVisible = false;
    // },
    // handleEditAction(val) {
    //   this.formUserNames = val.nameListString;
    //   this.examinePlanEditForm.userIds = val.idListString;
    //   this.remainUserList = val.dataSelectedUsers;

    //   this.dialogUserEditBoxVisible = false;
    // },
    // addUserBox() {
    //   this.dialogUserEditBoxVisible = true;
    // },
    // editUserBox(row) {
    //   this.dialogUserEditBoxVisible = true;
    // },
    //人员选择器end
    createReport(row) {
      getTaskReport({ planId: row.id }).then((data) => {
        this.$confirm(
          "总任务数：" +
            data.data.sum +
            "    ，未执行：" +
            data.data.notExecute +
            "    ，进行中：" +
            data.data.underway +
            "       ，已完成：" +
            data.data.finish +
            "     ，是否继续生成报告?",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          return generate({ planId: row.id, type: 2 }).then(() => {
            this.onLoad();
            this.$message.success("操作成功!");
          });
        });
      });
    },
    //    --》隐藏按钮
    hideCreateReportBtn(row) {
      return row.processStatus === 1;
    },
    hidePublishBtn(row) {
      return row.processStatus === 2;
    },
    hideEditBtn(row) {
      return row.processStatus === 2;
    },
    hideDelBtn(row) {
      return row.processStatus === 2;
    },
    closePublishDialog() {
      this.$refs.openPublishFormRef.resetForm();
      this.planId = "";
      this.openPublishFlag = false;
    },
    openPublishSubmit(row, done) {
      row.startTime = row.planTimeRange[0];
      row.endTime = row.planTimeRange[1];
      row.planId = this.planId;
      createTaskByPlanId(row).then(
        () => {
          this.onLoad();
          done();
          this.$message.success("操作成功!");
          this.closePublishDialog();
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    publish(row) {
      this.planId = row.id;
      this.openPublishFlag = true;
    },
    //提交方法=================================================================
    examinePlanEditSubmit(row, done) {
      row.systemNotifyWays = row.systemNotifyWays.join(",");
      if (this.editValue.length === 0) {
        this.$message.error("请选择考核题目!");
        done();
        return;
      }
      row.examineTopicIds = this.editValue.join(",");
      update(row).then(
        () => {
          this.onLoad();
          done();
          this.$message.success("操作成功!");
          this.quitExaminePlanEditDialog();
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    examinePlanAddSubmit(row, done) {
      //通知方式处理
      if (Array.isArray(row.systemNotifyWays)) {
        row.systemNotifyWays = row.systemNotifyWays.join(",");
      }
      if (this.addValue.length === 0) {
        this.$message.error("请选择考核内容!");
        done();
        return;
      }
      row.examineTopicIds = this.addValue.join(",");
      add(row).then(
        () => {
          this.onLoad();
          done();
          this.$message.success("操作成功!");
          this.quitExaminePlanAddDialog();
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    //关闭弹窗=================================================================
    quitExaminePlanViewDialog() {
      // this.$refs.examinePlanViewFormRef.resetForm();
      this.viewTopicData = [];
      this.openExaminePlanViewDialogFlag = false;
    },
    quitExaminePlanEditDialog() {
      // this.$refs.examinePlanEditFormRef.resetForm();
      this.examinePlanEditForm = {};
      this.editValue = [];
      this.openExaminePlanEditDialogFlag = false;
    },
    quitExaminePlanAddDialog() {
      this.$refs.examinePlanAddFormRef.resetForm();
      this.addValue = [];
      this.examineRepositoryList = [];
      this.openExaminePlanAddDialogFlag = false;
    },
    //打开弹窗--------------------------------------------------------------------
    openExaminePlanViewDialog(row) {
      if (!Array.isArray(row.systemNotifyWays)) {
        row.systemNotifyWays = row.systemNotifyWays
          ? row.systemNotifyWays.split(",")
          : [];
      }
      this.examinePlanViewForm = row;
      this.examinePlanViewForm.serviceType = String(
        this.examinePlanViewForm.serviceType
      );
      //根据计划id获取关联题目
      getPlanTopicListByPlanId({ planId: row.id }).then((res) => {
        this.viewTopicData = res.data;
        this.openExaminePlanViewDialogFlag = true;
      });
    },
    openExaminePlanEditDialog(row) {
      //人员选择器
      console.log("row openExaminePlanEditDialog==>", row);
      this.userEditBoxProjectId = row.projectId;

      //人员选择器
      this.userEditBoxProjectId = row.projectId;
      let remainUserList = [];
      let formUserNamesArray = [];
      let users = [];
      if (row.informantType === 2) {
        users = row.userIds.split(",");
      }
      getProjectUserList({ projectId: this.userEditBoxProjectId }).then(
        (resUser) => {
          resUser.data.forEach((item) => {
            if (users.includes(item.id)) {
              remainUserList.push(item);
              formUserNamesArray.push(item.realNameAndPhone);
            }
          });
          this.remainUserList = remainUserList;
          this.handleAction = 2;
          this.selectUserType = 1;
          this.formUserNames = formUserNamesArray.join(",");
          //人员选择器end

          //人员选择器end
          if (!Array.isArray(row.systemNotifyWays)) {
            row.systemNotifyWays = row.systemNotifyWays
              ? row.systemNotifyWays.split(",")
              : [];
          }
          this.examinePlanEditForm = row;
          this.examinePlanEditForm.serviceType = this.examinePlanEditForm.serviceType.toString();
          getPlanTopicIdListByPlanId({ planId: row.id }).then((res) => {
            this.editValue = res.data;
            this.openExaminePlanEditDialogFlag = true;
          });
        }
      );
    },
    openExaminePlanAddDialog() {
      //人员选择器
      this.handleAction = 1;
      this.selectUserType = 1;
      this.formUserNames = "";
      this.remainUserList = [];
      this.examinePlanAddForm.userIds = "";
      //人员选择器end
      setTimeout(() => {
        this.examinePlanAddForm.projectId = this.query.projectId;
      }, 0);
      this.openExaminePlanAddDialogFlag = true;
    },
    getProjectNameById(projectId) {
      let projectName = "";
      this.projectList.forEach(function (value, index, array) {
        if (value.id === projectId) {
          projectName = value.name;
          return;
        }
      });
      return projectName;
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success("操作成功!");
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success("操作成功!");
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success("操作成功!");
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success("操作成功!");
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (["edit", "view"].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query.serviceType = "";
      this.query.processStatus = "";
      this.query.name = "";
      this.query.groupName = "";
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      done();
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
      if (!this.query.projectId) {
        this.query.projectId = this.tempProjectId;
      }
      getList(
        Object.assign(
          { current: page.currentPage, size: page.pageSize },
          this.query
        )
      ).then(({ data }) => {
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
        if (this.firstDisplayFlag) {
          let ent = document.querySelector('input[placeholder="项目名称"]');
          ent.value = this.getProjectNameById(this.query.projectId);
          this.tempProjectId = this.query.projectId;
          //关闭默然显示，重刷页面时才开启默认显示
          this.firstDisplayFlag = false;
        }
      });
    },
  },
};
</script>

<style></style>
<style lang='scss' scoped>
::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 1px);
  max-width: calc(100% - 30px);
}
::v-deep .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
</style>
